import { ResolvedWalletTheme } from "./walletTheme.types";

export const DEFAULT_WALLET_THEME: ResolvedWalletTheme = {
  primary: {
    main: "#2065D1",
    light: "#76B0F1",
    dark: "#103996",
    contrastText: "#fff",
  },
  secondary: {
    main: "#3366FF",
    light: "#84A9FF",
    dark: "#1939B7",
    contrastText: "#fff",
  },
  info: {
    main: "#1890FF",
    light: "#74CAFF",
    dark: "#0C53B7",
    contrastText: "#fff",
  },
  success: {
    main: "#54D62C",
    light: "#AAF27F",
    dark: "#229A16",
    contrastText: "#212B36",
  },
  warning: {
    main: "#FFC107",
    light: "#FFE16A",
    dark: "#B78103",
    contrastText: "#212B36",
  },
  error: {
    main: "#FF4842",
    light: "#FFA48D",
    dark: "#B72136",
    contrastText: "#fff",
  },
  grey: {
    "100": "#F9FAFB",
    "200": "#F4F6F8",
    "300": "#DFE3E8",
    "400": "#C4CDD5",
    "500": "#919EAB",
    "600": "#637381",
    "700": "#454F5B",
    "800": "#212B36",
    "900": "#161C24",
  },
  text: {
    primary: "#212B36",
    secondary: "#637381",
    disabled: "#919EAB",
  },
  background: {
    default: "#F9FAFB",
    paper: "#fff",
    neutral: "#F4F6F8",
  },
  authPageColor: "#111111",
  countdownTimer: {
    calm: "#596592",
    warning: "#F7B801",
    critical: "#A30000",
  },
};
